import { RichTextNode } from '@/common/components/RichText/RichTextService';
import { hyperlinkStyles } from './Hyperlink.styles';

interface HyperlinkProps {
  node: RichTextNode;
}

export default function Hyperlink({ node }: HyperlinkProps) {
  if (!node.content || node.content.length === 0) return null;

  const linkContent = node.content[0].value;
  const { uri, target } = node.data as { uri: string; target?: string };

  // Handle JavaScript URLs with dangerouslySetInnerHTML
  if (uri.startsWith('javascript:')) {
    // Only allow Cookiebot functions for security
    const jsCode = uri.replace('javascript:', '').trim();
    const isCookiebotFunction = /^Cookiebot\.\w+\(\)$/.test(jsCode);

    if (!isCookiebotFunction) {
      // Fallback to regular link or return null for security
      return null;
    }

    const styleString = Object.entries(hyperlinkStyles)
      .map(
        ([key, value]) =>
          `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`
      )
      .join('; ');

    const htmlString = `<a href="${uri}" style="${styleString}">${linkContent}</a>`;

    return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }

  return (
    <a
      href={uri}
      target={target || '_blank'}
      rel="noopener noreferrer"
      style={hyperlinkStyles}
    >
      {linkContent}
    </a>
  );
}
